import { useContext, useEffect, useState } from 'react';
import { LuListStart } from "react-icons/lu";
import { GrStatusInfo } from "react-icons/gr";
import { GrStatusUnknown } from "react-icons/gr";
import api from '../../../Components/Api/Api';
//import { UserContext } from '../../context/UserContext';
import "./servicos.scss";
import Spinner from "../../../Components/Spinner";
import { Link} from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { UserContext } from '../../../context/UserContext';

const Servicos = () => {
  //const {user} = useContext(UserContext) 
  const {user} = useContext(UserContext)
  const [atualizar, setAtualizar] = useState(false)  
  const [ShowLoading, setShowLoading] = useState(false)  
  const [orcamentos, setOrcamentos] = useState([])
  const [page, setPage] = useState(0)
  const [perpage, setPerpage] = useState(10)
  const [linhastotal, setLinhastotal] = useState(0)
  const [dtini, setDtini] = useState('')
  const [dtfim, setDtfim] = useState(Date)
  const credentials = btoa(`${user.userRest}:${user.passRest}`); 
  const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
      "User-Agent": "PneusBrasil",
      "Accept": "application/json",
      'Authorization': `Basic ${credentials}`
  }   
  // const date = new Date();  
  // const ano =  date.getFullYear()
  // const mes =  date.getMonth() + 1
  // const dia = date.getDate()  
  function getentradas () {
    setTimeout(() => {
    setShowLoading(true)
    api.get('Ordemservico?filial='+user.filial+'&tpconsulta=1&Orcamento=&page='+page+'&perpage='+perpage+'&dtini='+dtini+'&dtfim='+dtfim,{headers})
    .then(response => {
          //console.log(response.data.Entradas)
          if (response.data.Ordens.length > 0 ){   
              //console.log(response.data.Entradas[0]['Num'])  
              setOrcamentos(response.data.Ordens)
              setLinhastotal(response.data.Ordens[0]['linhas']) 
              setAtualizar(true) 
              setShowLoading(false)  
              //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
          }else{
              //setInfoveuculo('Placa não cadastrada!')
              setShowLoading(false)
              setAtualizar(true)
          }                                   
    });
  }, 10 );        
  };

  const paginacao = (sentido: string) => {
    
    if(sentido === 'next' && page < (linhastotal - perpage)){
      console.log(sentido, ' - ',page + perpage)
      setPage(page + perpage)
      setAtualizar(false)
    }
    if(sentido === 'back' && page > 0){
      console.log(sentido, ' - ',page - perpage)
      setPage(page - perpage)
      setAtualizar(false)
    }    
  }

  const getdate = (el: any) => {
    if(el.target.id === 'data1' && el.target.value !== ''){
      //console.log("data 1 ",el.target.value.split('-').join(''))
      setDtini(el.target.value.split('-').join(''))
    }else if (el.target.id === 'data2' && el.target.value !== ''){ 
      //console.log("data 2 ",el.target.value.split('-').join(''))
      setDtfim(el.target.value.split('-').join(''))
    }
  }

  useEffect(() => {
    if(!atualizar){
      getentradas()
    }  
  })   
    return (
      <>
        <div className='mt-4'>
          {/* <label className='me-1' htmlFor="Orçamento nº">Orçamento nº:</label>
          <input type='text' className='me-2 sm-blok' onBlur={(e) => getnumorc(e)}></input> */}
          <label className='me-md-1' htmlFor="Dt Ini">Dt Ini:</label>
          <input className='sm-blok' type='date' id='data1' onBlur={(e) => getdate(e)}></input>
          <label className='ms-md-2 me-1 sm-blok' htmlFor="Dt Fim">Dt Fim:</label>
          <input className='' type='date' id='data2' onBlur={(e) => getdate(e)}></input>  

          <button className='ms-md-2 btn btn-success sm-blok' onClick={getentradas}>Filtrar</button>
        </div>      
        <div className='mt-4 text-center'>    
          {/* <Table striped bordered hover variant="light" responsive className="tabela"> */}
          <Table className='table table-bordered' responsive>
            <thead>
                <tr className='col-title'>
                <th>Id</th>
                <th>OS nº</th>
                <th className='cliente'>Cliente</th>
                <th>Prisma P1</th>
                <th>Prisma P2</th>
                <th>Placa</th>   
                <th>Modelo</th> 
                <th>Cor</th> 
                <th>Mecanico</th> 
                <th>Status</th>
                <th className='tamanho0'>Ações</th> 
                {/* <th>Editar</th>   */}
                </tr>
            </thead> 
            <tbody> 
            {orcamentos.map((list: any) => (           
              <tr key={list.id}>
                <td>{list.id}</td>
                <td><Link to='/OficinaItens' state={list.orcamento}>{list.orcamento}</Link></td>
                <td>{list.nomecliente}</td>
                <td>{list.p1}</td>
                <td>{list.p2}</td>
                <td>{list.placa}</td>
                <td>{list.modelo}</td>
                <td>{list.cor}</td>
                <td>{list.mecanico}</td>
                {list.status === 'Mecanica' ?
                  (<td className='bg-success text-white text-center'>{list.status}</td>) : (<td>{list.status}</td>)
                }
                <td className='acoes pt-2'>
                  {list.status !== 'Mecanica' ?
                  (<abbr title='Iniciar os serviços' className='me-2'>
                    <button className='btn btn-outline-warning btacoes'><Link to='/IniciarMecanica' state={list.orcamento}><LuListStart size={15} /></Link></button>
                  </abbr>): ('')              
                  }
                  { list.horainimeca !== '' ?
                  (<abbr title='Alterar informações da ordem de serviço.' className='me-2'>
                    <button className='btn btn-outline-danger btacoes'><Link to='/AlterarMecanica' state={list.orcamento}><GrStatusInfo size={15}/></Link></button>
                  </abbr>) : ('')
                  }
                  <abbr title='Mostrar informações da ordem de serviços.'>
                    <button className='btn btn-outline-success btacoes'><Link to='/OrdemInfo' state={list.orcamento}><GrStatusUnknown  size={15}/></Link></button>
                  </abbr>                
                </td>
                {/* <td><Link to='/StatusMecanico' state={list.orcamento}>Status</Link></td> */}
              </tr>
            ))}                         
            </tbody>
          {/* </Table>        */}
          </Table>
        </div>
        {orcamentos.length > 0 ? 
        (
          <div>
            <button onClick={() => {paginacao('next')}} className='btn btn-outline-success'>Proxima</button>
            <button onClick={() => {paginacao('back')}}className='ms-2 btn btn-outline-primary'>Anterior</button>
            <label className='ms-4'>Total de linhas {linhastotal}</label>
          </div>         
        ) : ('')
        }      
        <Spinner isLoading={ShowLoading} />                       
      </>
    );
};

export default Servicos;